// This modal box can be added to other things
// Will save and shut itself. And update redux store
// If a callback is given, will return id of saved or created customer

import * as React from 'react';
import { connect } from 'react-redux';

//import styles from './styles';
import { Alert } from 'react-native';
import { Footer, Container, Header, Content, Text, Label, Item, Input, Icon, Toast, Form, Spinner, View, Left, Right, Body, Button, Title, List, ListItem, InputGroup, TextInput } from 'native-base';
import FontAwesome from 'react-native-vector-icons/FontAwesome5';
import * as _ from 'lodash';
import Modal from '../../components/modal';
import CalCalDataApi from '../../api/CalCalDataApi';
import styles from './expenseTypeStyles';
import { Platform, InteractionManager } from 'react-native-web';
const minSearch = 2;
//import diff from 'object-diff';

class ExpenseTypeContainer extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = {
			isLoading: true,
			isModalVisible: true,
			isSaving: false,
			isSearching: false,
			searchString: ''
		};
		this.state = this.initialState;
	}

	componentDidMount() {
		InteractionManager.runAfterInteractions(() => {
			this.inputRef?._root?.focus();
		});
	}

	shouldComponentUpdate(nextProps, nextState) {
		//simple string compare
		if (nextState.searchString != this.state.searchString) {
			this.lookforCats(nextState.searchString);
		}
		return true;
	}

	lookforCats(search) {
		if (!search || search.length < minSearch) return false;
		CalCalDataApi.dataLoad('expenseCategories/search/' + search, this.props.jwt, res => {
			if (res) {
				this.setState({ foundCategories: res });
			} else {
				this.setState({ isError: true });
			}
		});
	}

	selectNew(master_id) {
		//wait. Only if master_id>1000 is this new!
		if (master_id < 1000) return this.selectCurrent(master_id);

		//needs to insert expense category with simply master_id. Everything else can be got (returned full record from API)

		this.setState({ isSaving: true });
		CalCalDataApi.dataInsert('expenseCategories', { master_id }, this.props.jwt, res => {
			//console.log('handleSubmit ',res)
			this.setState({ isSaving: false });
			if (res.success) {
				this.insertId = res.id;
				this.props.dispatch({
					type: 'INSERT/expenseCategory', //successful update send UPDATE(d) to store
					values: res.record //{...values, id:res.id}						//HAS to include response for correct ID
				});
				this.setState({ isModalVisible: false });
				this.props.closure(this.insertId);
			} else if (res.validationErrors) {
				console.log('validationErrors ', res.validationErrors);
				//throw new SubmissionError(res.validationErrors);
			} else {
				Alert.alert('Save failed, error ' + res.error + ' ' + res.status);
				//throw new SubmissionError(res.error);
			}
		});
	}

	selectCurrent(id) {
		this.setState({ isModalVisible: false });
		this.props.closure(id);
	}

	clearSearch() {
		this.setState({ searchString: '' });
		this.sbox?._root && this.sbox._root.clear();
		//console.log(this.sbox._root);
	}

	render() {
		const { foundCategories, searchString, isModalVisible, isSaving, isError } = this.state;
		const searching = searchString != '' && searchString.length >= minSearch;
		const foundMine = foundCategories && foundCategories.length && foundCategories.filter(v => v.id > 0 && v.id < 1000);
		const foundNew = foundCategories && foundCategories.length && foundCategories.filter(v => v.id >= 1000);
		const foundAssets = foundCategories && foundCategories.length && foundCategories.filter(v => v.id == 0);

		if (isError) {
			return <Text style={{ color: 'red' }}>Error loading!</Text>;
		} else {
			return (
				<Modal
					isOpen={isModalVisible}
					backButtonClose
					coverScreen
					swipeThreshold={100}
					animationDuration={150}
					style={styles.modalStyle}
					onBackdropPress={() => this.props.closure()}
					onClosed={() => this.props.closure()}>
					{!isSaving ? (
						<Header style={styles.modalHeader}>
							<Body>
								<Title>Find an Expense Type</Title>
							</Body>
						</Header>
					) : (
						<Header>
							<Spinner />
						</Header>
					)}
					<View style={styles.modalContainer}>
						<View style={styles.innerContainer}>
							<InputGroup>
								<Icon active name="search" />
								<Input autoFocus placeholder="Search for more" ref={r => (this.inputRef = r)} onChangeText={searchString => this.setState({ searchString })} />
								{searching && (
									<Button transparent onPress={() => this.clearSearch()}>
										<Icon name="close-circle" />
									</Button>
								)}
							</InputGroup>

							<Content>
								{!searching ? (
									<List>
										<ListItem itemDivider>
											<Text>YOUR EXPENSE TYPES</Text>
										</ListItem>
										{this.props.expenseCategories.map((item, i) => (
											<ListItem key={i} onPress={() => this.selectCurrent(item.id)}>
												<Text>{item.categoryName}</Text>
											</ListItem>
										))}
									</List>
								) : (
									<List>
										{!!foundMine && foundMine.length > 0 && (
											<>
												<ListItem itemDivider>
													<Text>YOUR EXPENSE TYPES</Text>
												</ListItem>
												{foundMine.map((item, i) => (
													<ListItem key={i} onPress={() => this.selectNew(item.id)}>
														<Text>{item.categoryName}</Text>
													</ListItem>
												))}
											</>
										)}
										{!!foundAssets && foundAssets.length > 0 && (
											<>
												<ListItem itemDivider backgroundColor="#888">
													<Text>ASSET TYPES</Text>
												</ListItem>
												{foundAssets.map((item, i) => (
													<ListItem key={i} onPress={() => this.props.swapToAsset()}>
														<Text>{item.categoryName}</Text>
													</ListItem>
												))}
											</>
										)}
										{!!foundNew && foundNew.length > 0 && (
											<>
												<ListItem itemDivider backgroundColor="#888">
													<Text>AVAILABLE EXPENSE TYPES</Text>
												</ListItem>
												{foundNew.map((item, i) => (
													<ListItem key={i} onPress={() => this.selectNew(item.id)}>
														<Text>{item.categoryName}</Text>
													</ListItem>
												))}
											</>
										)}
										{!foundNew && !foundMine && <Text note>No results</Text>}
									</List>
								)}
							</Content>
							{!!this.props.swapToAsset && (
								<Footer>
									<Button transparent onPress={() => this.props.swapToAsset()}>
										<FontAwesome name="toolbox" style={{ color: '#8fbcd6' }} />
										<Text style={{ color: '#8fbcd6' }}>Add an Asset</Text>
									</Button>
								</Footer>
							)}
						</View>
					</View>
				</Modal>
			);
		}
	}
}

const mapStateToProps = state => ({
	expenseCategories: state.globalReducer.expenseCategories,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token
});

export default connect(mapStateToProps)(ExpenseTypeContainer);
